import { useState, useEffect } from 'react';
import { apiRequest, trickleCreateObject, trickleListObjects } from '../../utils/api';

function RegisterForm({ onToggleForm }) {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        password: '',
        confirmPassword: ''
    });
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    try {

        const validateForm = () => {
            if (!formData.name.trim()) {
                setError('請輸入姓名');
                return false;
            }
            
            if (!formData.email.trim()) {
                setError('請輸入電子郵件');
                return false;
            }
            
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailRegex.test(formData.email)) {
                setError('請輸入有效的電子郵件地址');
                return false;
            }
            
            if (formData.password.length < 6) {
                setError('密碼長度至少需要 6 個字元');
                return false;
            }
            
            if (formData.password !== formData.confirmPassword) {
                setError('兩次輸入的密碼不相符');
                return false;
            }
            
            return true;
        };

        const handleChange = (e) => {
            const { name, value } = e.target;
            setFormData(prev => ({
                ...prev,
                [name]: value
            }));
            setError('');
        };

        const handleSubmit = async (e) => {
            e.preventDefault();
            setError('');

            if (!validateForm()) {
                return;
            }

            setIsLoading(true);

            try {
                const userData = {
                    name: formData.name,
                    email: formData.email,
                    password: formData.password,
                };

                const res = await apiRequest('POST', '/api/index/register', userData);
                if (!res.success) {
                    throw new Error(res.error);
                }


                const newUser = res.data;

                localStorage.setItem('token', newUser.token);
                localStorage.setItem('user', JSON.stringify({
                    id: newUser.id,
                    name: userData.name,
                    email: userData.email
                }));

                window.dispatchEvent(new Event('storage'));
                window.location.href = '/books';
            } catch (err) {
                setError(err.message || '註冊失敗，請稍後再試');
                console.error('註冊錯誤:', err);
            } finally {
                setIsLoading(false);
            }
        };

        return (
            <div className="auth-container" data-name="register-form">
                <h2 className="auth-title">註冊帳號</h2>
                {error && (
                    <div 
                        className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4" 
                        role="alert"
                        data-name="error-message"
                    >
                        {error}
                    </div>
                )}
                <form onSubmit={handleSubmit} className="auth-form">
                    <div>
                        <label htmlFor="name" className="block mb-2">姓名</label>
                        <input
                            type="text"
                            id="name"
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                            className="input"
                            placeholder="請輸入姓名"
                            disabled={isLoading}
                            data-name="name-input"
                        />
                    </div>
                    <div>
                        <label htmlFor="email" className="block mb-2">電子郵件</label>
                        <input
                            type="email"
                            id="email"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            className="input"
                            placeholder="請輸入電子郵件"
                            disabled={isLoading}
                            data-name="email-input"
                        />
                    </div>
                    <div>
                        <label htmlFor="password" className="block mb-2">密碼</label>
                        <input
                            type="password"
                            id="password"
                            name="password"
                            value={formData.password}
                            onChange={handleChange}
                            className="input"
                            placeholder="至少 6 個字元"
                            disabled={isLoading}
                            data-name="password-input"
                        />
                    </div>
                    <div>
                        <label htmlFor="confirmPassword" className="block mb-2">確認密碼</label>
                        <input
                            type="password"
                            id="confirmPassword"
                            name="confirmPassword"
                            value={formData.confirmPassword}
                            onChange={handleChange}
                            className="input"
                            placeholder="請再次輸入密碼"
                            disabled={isLoading}
                            data-name="confirm-password-input"
                        />
                    </div>
                    <button 
                        type="submit" 
                        className="btn btn-primary mt-4 w-full"
                        disabled={isLoading}
                        data-name="submit-button"
                    >
                        {isLoading ? (
                            <div className="flex items-center justify-center">
                                <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-black mr-2"></div>
                                註冊中...
                            </div>
                        ) : '註冊'}
                    </button>
                </form>
                <p className="text-center mt-4" data-name="login-link">
                    已經有帳號？{' '}
                    <button 
                        onClick={onToggleForm} 
                        className="text-blue-600 hover:underline"
                        disabled={isLoading}
                    >
                        立即登入
                    </button>
                </p>
            </div>
        );
    } catch (error) {
        console.error('註冊表單錯誤:', error);
        reportError(error);
        return null;
    }
}

export default RegisterForm;